import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { Seo } from "../components/Seo";
import { Nav } from "../components/landing/Nav";
import { Footer } from "../components/landing/Footer";
import { ARTICLES } from "../data/articles";

const ExplainersIndex = () => (
  <div className="bg-navy text-ink min-h-screen antialiased" data-testid="explainers-page">
    <Seo
      title="Private Credit Explainers"
      description="Plain-English guides to Australian private credit: bank lending comparisons, fees and conflicts, ASIC REP 814 valuations, real estate credit and corporate facilities."
      path="/explainers"
    />
    <Nav />
    <main className="max-w-6xl mx-auto px-6 py-16">
      <span className="text-xs font-mono text-cy uppercase tracking-widest">KNOWLEDGE PILLARS</span>
      <h1 className="font-display text-4xl md:text-6xl text-white uppercase mt-2">
        Private Credit <span className="text-cy">Explainers</span>
      </h1>
      <p className="text-base md:text-lg text-mut leading-relaxed mt-4 max-w-3xl">
        Factual, general education on how Australia's A$234.5b private credit market works — written for
        wholesale investors, advisers and borrowers, and kept clear of personal advice.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12">
        {ARTICLES.map((a) => (
          <Link
            key={a.slug}
            to={`/explainers/${a.slug}`}
            data-testid={`explainer-link-${a.slug}`}
            className="p-6 rounded-xl bg-surface border border-line hover:border-cy/40 transition-colors group flex flex-col"
          >
            <div className="flex items-center justify-between text-xs font-mono text-cy font-bold">
              <span>{a.tag}</span>
              <span className="text-slate-500 font-normal inline-flex items-center gap-1">
                <Clock className="w-3 h-3" /> {a.readMinutes} MIN READ
              </span>
            </div>
            <h2 className="font-display text-2xl text-white uppercase mt-3 group-hover:text-cy transition-colors">
              {a.title}
            </h2>
            <p className="text-sm text-mut font-body mt-3 leading-relaxed">{a.excerpt}</p>
            <span className="mt-auto pt-4 text-slate-500 inline-flex items-center gap-1 text-[10px] font-mono">
              READ EXPLAINER <ArrowUpRight className="w-3 h-3" />
            </span>
          </Link>
        ))}
      </div>
    </main>
    <Footer />
  </div>
);

export default ExplainersIndex;
